import { createContext } from 'react';

const MMMContext = createContext();

export default MMMContext;
